var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('b-row',{staticClass:"text-center",staticStyle:{"margin-top":"100px","margin-bottom":"100px"}},[_c('b-col',{attrs:{"md":"6","offset-md":"3"}},[_c('b-card',{staticClass:"mb-2",staticStyle:{"max-width":"30rem"},attrs:{"title":"Bitte warten...","tag":"article"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }